/**
 * Manifest schemas
 */

import { favoriteSchemaLegacy, hotkeySchema, maturitySchema } from '@tunasong/schemas'
import { z } from 'zod/v4'

/** @todo these should be in the plugins and "injected" into the manifest (e.g., during build?) */
export const midiPluginSchema = z
  .object({
    midi: z.boolean().describe('MIDI support').default(false),
    btMidi: z.boolean().describe('Bluetooth MIDI support (experimental)').default(false),
    btMidiAutoConnect: z.boolean().describe('Auto-connect to paired Bluetooth MIDI devices').default(false),
  })
  .optional()

export const chordPlayerPluginSchema = z
  .object({
    play: z.boolean().describe('Play chords on selection').default(false),
  })
  .optional()

export const chordPluginSchema = z
  .object({
    showTranspose: z.boolean().describe('Show transposition with the chord, e.g., +2').default(true),
  })
  .optional()

export const userConfigSchema = z.object({
  featureMaturity: maturitySchema.optional().default('stable'),
  theme: z.enum(['light', 'dark', 'system']).optional().default('system'),
  /** Favorites - entity IDs or page path (e.g., /app/guitarpatterns) of the user's favorites */
  favorites: z.array(favoriteSchemaLegacy).optional(),
  /** AI Configuration */
  ai: z.record(z.string(), z.unknown()).optional(),
  /** The keyboard shortcuts / hotkeys for the user. Format handled by the useHotkeys hook */
  hotkeys: z.array(hotkeySchema).default([
    { hotkey: 'opt+up', label: 'Block: Move Up', commandId: 'block-move-up' },
    { hotkey: 'opt+down', label: 'Block: Move Down', commandId: 'block-move-down' },
    { hotkey: 'shift+mod+d', label: 'Block: Duplicate', commandId: 'block-duplicate' },
    { hotkey: 'shift+mod+backspace', label: 'Block: Delete', commandId: 'block-delete' },
    { hotkey: 'mod+b', label: 'Format: Bold', commandId: 'format-bold' },
    { hotkey: 'mod+i', label: 'Format: Italic', commandId: 'format-italic' },
  ]),
  musicPreferences: z
    .object({
      transpose: z.number().optional(),
      noteFormat: z.enum(['standard', 'norwegian']).optional(), // Norwegian uses H instead of B
    })
    .optional(),
  plugins: z
    .lazy(() =>
      z
        .object({
          // The key is the plugin key / id
          midi: midiPluginSchema,
          'chord-player': chordPlayerPluginSchema,
          chord: chordPluginSchema,
        })
        .loose()
    )
    .optional()
    .default({}),
})
